/** Keeps tab content mounted; toggles visibility instead of unmounting. */
export default function TabKeepAlive({ show, children }) {
  return (
    <div
      className="smc-tab-keep-alive"
      style={{ display: show ? 'block' : 'none' }}
      aria-hidden={show ? undefined : true}
    >
      {children}
    </div>
  );
}
